export const COS_CDN_BASE = 'https://tx-file.hewoxue.com/';
/** 将 COS 对象键转为可访问的 CDN 地址 */
export function resolveCosUrl(key) {
    if (!key)
        return '';
    if (key.startsWith('data:') || key.startsWith('http://') || key.startsWith('https://')) {
        return key;
    }
    return `${COS_CDN_BASE}${key.replace(/^\//, '')}`;
}
/** 将 CDN 完整地址还原为 COS 对象键 */
export function toCosKey(url) {
    if (!url)
        return '';
    if (url.startsWith(COS_CDN_BASE)) {
        return url.slice(COS_CDN_BASE.length);
    }
    return url;
}
